<div class="seed-return-add-prod" (window:resize)="onresize($event)">
    <div class="prod-top-sec">
        <h3 class="xs-pl-0">
            Add Product(s) to COI Request
        </h3>

        <div class="form-sec">
            <div class="row margin-r0">
                <div class="col-md-12 col-lg-12 smallPadRgt0">
                    <app-cppfilter [filters]="filterTypeList" [isFromCOIPage]="true" (SearchFilter)="filterProductGridData($event)" (ClearFilter)="clearGridData($event)"></app-cppfilter>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 tabBgColor padding-t20">
            <mat-tab-group disableRipple [animationDuration]="'0ms'" class="matTabs prepayLandingTab" (selectedTabChange)="tabChanged($event)">
                <mat-tab>
                    <ng-template mat-tab-label>
                        <div class="tab-head">
                            <h4>
                                COI At ShipTo Location
                            </h4>
                        </div>
                    </ng-template>

                    <div class="tableContainer prodTableContainer accInvProdTable">
                        <table mat-table [dataSource]="productAllDataSource" multiTemplateDataRows class="matTables productTable">
                            <ng-container matColumnDef="Product Name">
                                <th mat-header-cell *matHeaderCellDef class="productNameBlock">Product Name </th>
                                <td mat-cell *matCellDef="let element" class="order-info cursor-defualt">
                                    <p class="vendorName"> {{element.itemVendorName}}</p>
                                    <p class="grower-name">{{element.itemDescription}}</p>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="detail">
                                <th mat-header-cell *matHeaderCellDef class="package text-center">&nbsp;</th>
                                <td mat-cell *matCellDef="let element" class="text-center">
                                    <div class="showHideDetails text-center md-pt-0" (click)="showProductDetails(element);">
                                        <a>{{element.isSelected ? 'Hide Product Details':'View Product Details' }}</a>
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="Item Number">
                                <th mat-header-cell *matHeaderCellDef class="text-center itemNumber"> Item Number </th>
                                <td mat-cell *matCellDef="let element" class="text-center">
                                    <span> {{element.itemNumber}} </span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="Available Units">
                                <th mat-header-cell *matHeaderCellDef class="text-center availableUnits"> Available Units </th>
                                <td mat-cell *matCellDef="let element" class="text-center">
                                    <span> {{element.availableUnits}} </span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="Pack Size">
                                <th mat-header-cell *matHeaderCellDef class="text-center packSize"> Pack Size </th>
                                <td mat-cell *matCellDef="let element" class="text-center">
                                    <span> {{element.packageSize}} </span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="Product Line">
                                <th mat-header-cell *matHeaderCellDef class="text-center prodLine">  Product Line </th>
                                <td mat-cell *matCellDef="let element" class="text-center product-line">
                                    <div class="checkBoxOuterBg">
                                        <div class="chkboxOuter">
                                            <i class="fas fa-check checkShowHide"></i>
                                            <mat-checkbox class="custom-checkbox select-all-check hide" [ngModel]="element.IsProductSelected" *ngIf="element.IsProductSelected"></mat-checkbox>
                                        </div>
                                    </div>
                                    <span>
                                        {{element.productLine}}
                                    </span>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="expandedDetail">
                                <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length" [style.display]="element.isSelected ? 'table-cell' : 'none'">
                                    <div>
                                        <div class="cpp-prod-info mobile-nested-table">
                                            <table style="width:100%" class="m-0">
                                                <thead>
                                                    <tr>
                                                        <th width="10%" class="text-left">Item # </th>
                                                        <th width="10%"> GTIN </th>
                                                        <th width="15%"> Product Line </th>
                                                        <th width="25%"> Active Ingredients </th>
                                                        <th width="10%"> National Price </th>
                                                        <th width="11%"> Pallet Quantity </th>
                                                        <th width="10%"> Restricted Use </th>
                                                        <th width="10%"> Non-Returnable </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr class="">
                                                        <th width="10%" class="d-block d-sm-block d-md-none">Item # </th>

                                                        <td width="10%" class="text-left"><p>{{element.itemNumber}}</p> </td>
                                                        <th width="10%" class="d-block d-sm-block d-md-none"> GTIN </th>
                                                        <td width="10%"><p>{{element.gtin}}</p></td>
                                                        <th width="15%" class="d-block d-sm-block d-md-none"> Product Line </th>

                                                        <td width="15%"> <p>{{element.productLine}}</p> </td>
                                                        <th width="25%" class="d-block d-sm-block d-md-none"> Active Ingredients </th>
                                                        <td width="25%"><p>{{element.activeIngredient}}</p> </td>
                                                        <th width="10%" class="d-block d-sm-block d-md-none"> National Price </th>

                                                        <td width="10%"> <p *ngIf="element.price>0"> {{element.price | number:'1.4-4'}}/{{element.pricingUOM}}</p> </td>
                                                        <th width="11%" class="d-block d-sm-block d-md-none"> Pallet Quantity </th>
                                                        <td width="11%"><p>{{element.palletQuantity | number:'1.4-4'}}</p> </td>
                                                        <th width="10%" class="d-block d-sm-block d-md-none"> Restricted Use </th>

                                                        <td width="10%"><p>{{element.restrictedUse}}</p> </td>
                                                        <th width="6%" class="d-block d-sm-block d-md-none"> Non-Returnable </th>
                                                        <td width="6%"><div [ngClass]="{'oval-shape returnable':( element.returnable ==='X')}"><p>{{element.returnable}}</p></div></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'ineligible-row':(row?.displayMessage!=null),'active':(row?.IsProductSelected)}" (click)="keepRecords(row,true)"></tr>
                            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                        </table>
                    </div>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <div class="tab-head">
                            <h4>COI At Parent Location</h4>
                        </div>
                    </ng-template>

                    <div class="tableContainer prodTableContainer compInvProdTable">
                        <table mat-table [dataSource]="parentAccountDataSource" multiTemplateDataRows class="matTables productTable">
                            <ng-container matColumnDef="Product Name">
                                <th mat-header-cell *matHeaderCellDef class="productNameBlock">Product Name </th>
                                <td mat-cell *matCellDef="let element" class="order-info">
                                    <p class="vendorName"> {{element.itemVendorName}}</p>
                                    <p class="grower-name">{{element.itemDescription}}</p>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="detail">
                                <th mat-header-cell *matHeaderCellDef class="package text-center">&nbsp;</th>
                                <td mat-cell *matCellDef="let element" class="text-center">
                                    <div class="showHideDetails text-center md-pt-0" (click)="showProductDetails(element);">
                                        <a>{{element.isSelected ? 'Hide Product Details':'View Product Details' }}</a>
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="Item Number">
                                <th mat-header-cell *matHeaderCellDef class="text-center itemNumber"> Item Number </th>
                                <td mat-cell *matCellDef="let element" class="text-center">
                                    <span> {{element.itemNumber}} </span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="Available Units">
                                <th mat-header-cell *matHeaderCellDef class="text-center availableUnits"> Available Units </th>
                                <td mat-cell *matCellDef="let element" class="text-center">
                                    <span> {{element.availableUnits}} </span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="Pack Size">
                                <th mat-header-cell *matHeaderCellDef class="text-center packSize"> Pack Size </th>
                                <td mat-cell *matCellDef="let element" class="text-center">
                                    <span> {{element.packageSize}} </span>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="Product Line">
                                <th mat-header-cell *matHeaderCellDef class="text-center prodLine">  Product Line </th>
                                <td mat-cell *matCellDef="let element" class="text-center product-line">
                                    <div class="checkBoxOuterBg">
                                        <div class="chkboxOuter">
                                            <i class="fas fa-check checkShowHide"></i>
                                            <mat-checkbox class="custom-checkbox select-all-check hide" [ngModel]="element.IsProductSelected" *ngIf="element.IsProductSelected"></mat-checkbox>
                                        </div>
                                    </div>
                                    <span>
                                        {{element.productLine}}
                                    </span>
                                </td>
                            </ng-container>

                            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                            <ng-container matColumnDef="expandedDetail">
                                <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length" [style.display]="element.isSelected ? 'table-cell' : 'none'">
                                    <div>
                                        <div class="cpp-prod-info mobile-nested-table">
                                            <table style="width:100%" class="m-0">
                                                <thead>
                                                    <tr>
                                                        <th width="10%" class="text-left">Item # </th>
                                                        <th width="10%"> GTIN </th>
                                                        <th width="15%"> Product Line </th>
                                                        <th width="25%"> Active Ingredients </th>
                                                        <th width="10%"> National Price </th>
                                                        <th width="11%"> Pallet Quantity </th>
                                                        <th width="10%"> Restricted Use </th>
                                                        <th width="10%"> Non-Returnable </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr class="">
                                                        <th width="10%" class="d-block d-sm-block d-md-none">Item # </th>

                                                        <td width="10%" class="text-left"><p>{{element.itemNumber}}</p> </td>
                                                        <th width="10%" class="d-block d-sm-block d-md-none"> GTIN </th>
                                                        <td width="10%"><p>{{element.gtin}}</p></td>
                                                        <th width="15%" class="d-block d-sm-block d-md-none"> Product Line </th>

                                                        <td width="15%"> <p>{{element.productLine}}</p> </td>
                                                        <th width="25%" class="d-block d-sm-block d-md-none"> Active Ingredients </th>
                                                        <td width="25%"><p>{{element.activeIngredient}}</p> </td>
                                                        <th width="10%" class="d-block d-sm-block d-md-none"> National Price </th>

                                                        <td width="10%"> <p *ngIf="element.price>0"> {{element.price | number:'1.4-4'}}/{{element.pricingUOM}}</p> </td>
                                                        <th width="11%" class="d-block d-sm-block d-md-none"> Pallet Quantity </th>
                                                        <td width="11%"><p>{{element.palletQuantity | number:'1.4-4'}}</p> </td>
                                                        <th width="10%" class="d-block d-sm-block d-md-none"> Restricted Use </th>

                                                        <td width="10%"><p>{{element.restrictedUse}}</p> </td>
                                                        <th width="6%" class="d-block d-sm-block d-md-none"> Non-Returnable </th>
                                                        <td width="6%"><div [ngClass]="{'oval-shape returnable':( element.returnable ==='X')}"><p>{{element.returnable}}</p></div></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'ineligible-row':(row?.displayMessage!=null),'active':(row?.IsProductSelected)}" (click)="keepRecords(row,false)"></tr>
                            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                        </table>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
    <div class="row add-order-sec margin-l0 margin-r0">
        <div class="col-md-2 padding-l0">
            <button mat-raised-button class="btns wide100" color="primary" [disabled]="isProductNotAdded" (click)="addSelectedProductToOrder()">Add To Request</button>
        </div>
        <div class="col-md-2 padding-l0" *ngIf="isShowExportButton()">
            <button mat-raised-button class="btns wide100" color="primary" [disabled]="isDisableExportButton()" (click)="export()">Export</button>
        </div>
        <div class="col-md-8 text-right" *ngIf="isShowExportButton()">
            <span class="count">Product selected <span>{{getSelectedCount()}}</span></span>
        </div>
        <div class="col-md-10 text-right" *ngIf="!isShowExportButton()">
            <span class="count">Product selected <span>{{getSelectedCount()}}</span></span>
        </div>
    </div>
</div>
